import { render, staticRenderFns } from "./ReleaseFileList.vue?vue&type=template&id=7f3a543e"
import script from "./ReleaseFileList.vue?vue&type=script&lang=js"
export * from "./ReleaseFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports